import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { UpgradeContainer } from '@/containers/upgrade/upgrade-container.component';
import { parseUpgradeSearch } from '@/lib/upgrade-link';
import { createFileRoute } from '@tanstack/react-router';

/**
 * The guided upgrade: choose a plan and seats, add Pro's add-ons, then review
 * and pay. Every workspace buys v4 plans here, whatever catalog it's on.
 */
export const Route = createFileRoute('/upgrade')({
  validateSearch: parseUpgradeSearch,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  return (
    <>
      <Head heading='Upgrade' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <UpgradeContainer search={search} />
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
